import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IRollSelectBehavior } from "../../../../documaker/domain/format/objects";

export interface IRollSelectBehaviorPropertyEditable {
  rollSelectBehavior(): IPropertyEditable<IRollSelectBehavior>;
}

export function instanceOfIRollSelectBehaviorPropertyEditable(instance: any): instance is IRollSelectBehaviorPropertyEditable {
  return instance
      && instance.rollSelectBehavior
      && instanceOfIPropertyEditable<IRollSelectBehavior>(instance.rollSelectBehavior());
}
